import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiChevronDown, FiCheck, FiMapPin } = FiIcons;

function ProgramAccordion({ program, isOpen, onToggle }) {
  return (
    <article className={`program-card ${isOpen ? 'open' : ''}`}>
      <button
        className="program-trigger"
        onClick={onToggle}
        aria-expanded={isOpen}
        aria-controls={`program-details-${program.name}`}
      >
        <span>
          <strong>{program.name}</strong>
          <small>{program.badge}</small>
        </span>
        <SafeIcon icon={FiChevronDown} className="chevron" aria-hidden="true" />
      </button>

      <motion.div
        className="program-content"
        id={`program-details-${program.name}`}
        initial={false}
        animate={{
          height: isOpen ? 'auto' : 0,
          opacity: isOpen ? 1 : 0,
        }}
        transition={{ duration: 0.3, ease: 'easeInOut' }}
        style={{ overflow: 'hidden' }}
      >
        <div className="program-inner">
          <p className="program-summary">{program.summary}</p>

          <div
            className="spec-table"
            role="table"
            aria-label={`${program.name} details`}
          >
            {program.specs.map(([label, value]) => (
              <div className="spec-row" role="row" key={label}>
                <span role="cell">{label}</span>
                <strong role="cell">{value}</strong>
              </div>
            ))}
          </div>

          {program.paragraphs.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}

          <ul className="highlight-list">
            {program.highlights.map((item) => (
              <li key={item}>
                <SafeIcon icon={FiCheck} />
                {item}
              </li>
            ))}
          </ul>

          <div className="location-title">
            <SafeIcon icon={FiMapPin} />
            <span>{program.address}</span>
          </div>

          <iframe
            className="map"
            src={program.mapEmbedUrl}
            width="600"
            height="450"
            title={`Google Maps location for ${program.name}`}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </motion.div>
    </article>
  );
}

export default ProgramAccordion;